import { ControlPanel, Table, PaginationContainer, QueryParamsManager } from "./components";
import style from "./CustomersPage.module.scss";

export function CustomersPage() {
  return (
    <main className={style.page}>
      <ControlPanel />
      <div className={style.container}>
        <Table />
        <PaginationContainer />
        <QueryParamsManager />
      </div>
    </main>
  );
}
 